import { defineStore } from 'pinia';
import http from '../api/httpRequest.js';

export default defineStore('contactGroupStore', {
  state: () => ({ groups: [], items: [] }),
  getters: {
    groupsOf: state => type => state.groups.filter(g => g.groupType === type),
    groupIdOf: state => (groupType, targetType, targetId) => {
      const item = state.items.find(i => i.groupType === groupType && i.targetType === targetType && `${i.targetId}` === `${targetId}`);
      return item ? item.groupId : 0;
    }
  },
  actions: {
    async load() {
      const data = await http({ url: '/contact/group/config', method: 'get' });
      this.groups = data.groups || [];
      this.items = data.items || [];
    },
    clear() { this.groups = []; this.items = []; },
    async create(groupType, name) {
      await http({ url: '/contact/group', method: 'post', data: { groupType, name } });
      await this.load();
    },
    async update(id, name, sort) {
      await http({ url: '/contact/group', method: 'put', data: { id, name, sort } });
      await this.load();
    },
    async reorder(groupType, groupIds) {
      await http({ url: '/contact/group/sort', method: 'put', data: { groupType, groupIds } });
      await this.load();
    },
    async remove(id) {
      await http({ url: `/contact/group/${id}`, method: 'delete' });
      await this.load();
    },
    async assign(groupType, groupId, targetType, targetId) {
      await http({ url: '/contact/group/assign', method: 'put', data: { groupType, groupId, targetType, targetId } });
      await this.load();
    }
  }
});
